// TODO: 暂时用来内部传函数的，待优化

export const FnBridge = {
  createOrder: null,
}
